import { render, staticRenderFns } from "./HealthManage.vue?vue&type=template&id=94428c86&scoped=true&"
import script from "./HealthManage.vue?vue&type=script&lang=js&"
export * from "./HealthManage.vue?vue&type=script&lang=js&"
import style0 from "./HealthManage.vue?vue&type=style&index=0&id=94428c86&prod&lang=scss&scoped=true&"
import style1 from "./HealthManage.vue?vue&type=style&index=1&id=94428c86&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94428c86",
  null
  
)

export default component.exports